// Support component names relative to this directory:
// require('tailwindcss/tailwind.css');
// require('../styles/application.css');
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import * as Turbo from "@hotwired/turbo"
// require('@hotwired/turbo-rails')
// export { Turbo }

Rails.start()
// require('@rails/ujs').start();
ActiveStorage.start()
// require('@rails/activestorage').start();

var ReactRailsUJS = require('react_ujs');
var componentRequireContext = require.context('components', true);
// ReactUJS.getConstructor = ReactUJS.constructorFromRequireContext(require.context('components', true));

ReactRailsUJS.useContext(componentRequireContext);
ReactRailsUJS.handleEvent('turbo:render', ReactRailsUJS.handleMount)
ReactRailsUJS.handleEvent('turbo:frame-load', ReactRailsUJS.handleMount)
ReactRailsUJS.handleEvent('turbo:frame-render', ReactRailsUJS.handleUnmount)

// Fix Alpine.js v2 not reinitializing after Turbo back/forward navigation
// Before Turbo caches the page, we need to:
// 1. Reset Alpine component state to initial values
// 2. Remove Alpine's internal references so it reinitializes fresh
document.addEventListener('turbo:before-cache', function() {
  document.querySelectorAll('[x-data]').forEach(function(el) {
    // Reset any open/expanded states to their default (closed)
    if (el.__x && el.__x.$data) {
      if ('open' in el.__x.$data) {
        el.__x.$data.open = false;
      }
    }
    // Remove Alpine's internal reference so it will reinitialize on restore
    delete el.__x;
  });
});

// document.addEventListener('turbo:frame-load', function (_e) {
//   console.log("turbo:frame-load");
//   ReactRailsUJS.mountComponents();
// }, false);

// var componentRequireContext = require.context('components', true);
// ReactRailsUJS.useContext(componentRequireContext);
// $(document).on("turbo:load", () => {
//   console.log("turbo!");
// });


// rich text editor
require('trix');
require('@rails/actiontext');

// Chartkick charts
import "chartkick/chart.js";
